import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip
} from '@mui/material';
import { Box } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

// table component
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DateRange } from 'react-date-range';
import { MdOutlinePreview, MdUploadFile, MdUpload, MdOutlineAdd } from 'react-icons/md';
import { fDate } from '../../utils/formatTime';

import { UserMoreMenu } from '../../components/_dashboard/user';

function IndividualCommission({
  StyledTableCell,
  StyledTableRow,
  setOpen2,
  setValidationMsg2,
  individualArray,
  individualArrayList,
  setIndividualArrayList,
  loanTypesList,
  individualCommission,
  setIndividualCommission,
  branches,
  setDeleteConfirm1,
  setIndividualCommissionEdit,
  individualEditDialogOpen,
  individualDeleteDialogOpen
}) {
  const [commissionDateRange, setCommissionDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);

  const handleAddIndividual = () => {
    if (individualCommission.loanType === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select loan type');
      return;
    }

    if (individualCommission.branch === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select branch');
      return;
    }

    if (individualCommission.commission === '') {
      setOpen2(true);
      setValidationMsg2('Please enter commission %');
      return;
    }

    if (Number(individualCommission.commission) > 100) {
      setOpen2(true);
      setValidationMsg2('Please enter valid commission %');
      return;
    }

    const newLoanName = JSON.parse(individualCommission.loanType).loanName;
    const newBranchName = JSON.parse(individualCommission.branch).branchName;

    const alreadyExists = individualArrayList.some(
      (item) =>
        JSON.parse(item.loanType).loanName === newLoanName &&
        JSON.parse(item.branch).branchName === newBranchName
    );

    if (alreadyExists) {
      setOpen2(true);
      setValidationMsg2('Loan Name already exists - Please try entering with another Loan Name');
      return;
    }

    const newCommission = {
      ...individualCommission,
      isIndividualCommissionType: true,
      aggrementCommissionId: null
    };

    setIndividualArrayList((prev) => [...prev, newCommission]);

    setIndividualCommission({
      loanType: ' ',
      branch: ' ',
      commission: '',
      isIndividualCommissionType: null,
      aggrementCommissionId: null
    });
  };

  return (
    <Box className="">
      <Box className="viewLeadCard" mb={3}>
        <Grid container spacing={3} mb={3}>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Loan Type
              </Typography>
              <Select
                fullWidth
                value={individualCommission.loanType}
                onChange={(e) => {
                  setIndividualCommission((prev) => ({
                    ...prev,
                    loanType: e.target.value
                  }));
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${individualCommission.loanType}`
                }}
              >
                <MenuItem value=" ">Select Loan Type</MenuItem>
                {loanTypesList.length > 0
                  ? loanTypesList.map((item, index) => {
                      const itemValue = {
                        loanId: item.loanId,
                        loanName: item.loanName
                      };
                      console.log(item);
                      return (
                        <MenuItem value={JSON.stringify(itemValue)} key={index}>
                          {item.loanName}
                        </MenuItem>
                      );
                    })
                  : ''}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Branch
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${individualCommission.branch}`
                }}
                value={individualCommission.branch}
                onChange={(e) => {
                  setIndividualCommission((prev) => ({
                    ...prev,
                    branch: e.target.value
                  }));
                }}
              >
                <MenuItem value=" ">Select Branch</MenuItem>
                {branches !== undefined && branches.length > 0
                  ? branches.map((item, index) => {
                      const itemValue = {
                        branchId: item.branchId,
                        branchName: item.branchName
                      };
                      return (
                        <MenuItem value={JSON.stringify(itemValue)} key={index}>
                          {item.branchName}
                        </MenuItem>
                      );
                    })
                  : ''}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Commission %
              </Typography>
              <TextField
                type="number"
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Commission %"
                value={individualCommission.commission}
                onChange={(e) => {
                  setIndividualCommission((prev) => ({
                    ...prev,
                    commission: e.target.value
                  }));
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box>
              <Typography variant="h6" className="formLabel">
                Date Range
              </Typography>

              <Select
                fullWidth
                value={commissionDateRange}
                className="datesSelect"
                inputProps={{ className: 'textInput' }}
                MenuProps={{ className: 'menuOpened' }}
                renderValue={() => {
                  if (!individualCommission.startDate && !individualCommission.endDate) {
                    return <span style={{ color: '#999' }}>Select Date Range</span>;
                  }

                  return `${fDate(individualCommission.startDate)} to ${fDate(
                    individualCommission.endDate
                  )}`;
                }}
              >
                <DateRange
                  editableDateInputs={false}
                  onChange={(item) => {
                    const selection = item.selection;

                    setCommissionDateRange([selection]);

                    setIndividualCommission((prev) => ({
                      ...prev,
                      startDate: selection.startDate,
                      endDate: selection.endDate
                    }));
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={commissionDateRange}
                />
              </Select>
            </Box>
          </Grid>
        </Grid>
        <Box textAlign="right">
          <Button
            className="mainBtn otherBtn"
            variant="contained"
            onClick={(e) => handleAddIndividual(e)}
          >
            Add Commission
          </Button>
        </Box>
      </Box>
      <Box className="greenBorder tableBox">
        <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: '' }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Loan Type</StyledTableCell>
                <StyledTableCell align="">Branch</StyledTableCell>
                <StyledTableCell align="">Commission %</StyledTableCell>
                <StyledTableCell align="" width={80}>
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {individualArrayList &&
                individualArrayList?.map((item, index) => (
                  <StyledTableRow>
                    <StyledTableCell align="left">
                      {JSON.parse(item.loanType).loanName}
                    </StyledTableCell>

                    <StyledTableCell align="left">
                      {JSON.parse(item.branch).branchName}
                    </StyledTableCell>
                    <StyledTableCell align="left">{item.commission}</StyledTableCell>
                    <StyledTableCell align="">
                      <UserMoreMenu
                        parent="individual-agreement"
                        setIndividualCommissionEdit={setIndividualCommissionEdit}
                        setDeleteConfirm1={setDeleteConfirm1}
                        itemList={item}
                        indexValue={index}
                        individualEditDialogOpen={individualEditDialogOpen}
                        individualDeleteDialogOpen={individualDeleteDialogOpen}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default IndividualCommission;
